import { render } from "./notifications.vue?vue&type=template&id=5ee4c0b2&lang=pug"
import script from "./notifications.vue?vue&type=script&lang=js"
export * from "./notifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/topBar/notifications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ee4c0b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ee4c0b2', __exports__)) {
    api.reload('5ee4c0b2', __exports__)
  }
  
  module.hot.accept("./notifications.vue?vue&type=template&id=5ee4c0b2&lang=pug", () => {
    api.rerender('5ee4c0b2', render)
  })

}


export default __exports__